
<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4 white--text pa-2">
      <h2 class="card--title">Presumptive Information</h2>
      <v-spacer />
      <v-btn
        :to="'/presumptive-edit/' + presumptiveDataEach.id"
        fab
        dark
        small
        color="orange lighten-1"
        class="mr-2 white--text"
        depressed
      >
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Code</th>
              <th class="text-left">Name</th>
              <th class="text-left">Township</th>
              <th class="text-left">Age</th>
              <th class="text-left">Sex</th>
              <th class="text-left">Case Found at</th>
              <th class="text-left">
                <span
                  v-if="
                    presumptiveDataEach.case_found_at == 2 ||
                    presumptiveDataEach.case_found_at == 3
                  "
                  >Index Case</span
                >
                <span v-if="presumptiveDataEach.case_found_at == 5"
                  >Previous ID</span
                >
              </th>
              <th
                v-if="
                  presumptiveDataEach.case_found_at == 2 ||
                  presumptiveDataEach.case_found_at == 3
                "
              >
                Type of DRTB Contact
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ presumptiveDataEach.unique_number }}</td>
              <td>{{ presumptiveDataEach.name }}</td>
              <td>
                {{
                  presumptiveDataEach.township
                    ? presumptiveDataEach.township.short_code
                    : ""
                }}
              </td>
              <td>{{ presumptiveDataEach.age }}</td>
              <td>{{ presumptiveDataEach.sex == 1 ? 'Male' : presumptiveDataEach.sex == 2 ? 'Female' : 'Not found' }}</td>
              <td>{{ presumptiveDataEach.case_found_at_name.name }}</td>
              <td>
                <span
                  v-if="
                    presumptiveDataEach.case_found_at == 2 ||
                    presumptiveDataEach.case_found_at == 3
                  "
                  >({{ presumptiveDataEach.index_case_no }})({{
                    presumptiveDataEach.index_case_year
                  }})</span
                >
                <span v-if="presumptiveDataEach.case_found_at == 5"
                  >({{ presumptiveDataEach.index_case_no }})({{
                    presumptiveDataEach.index_case_year
                  }})</span
                >
                <v-btn
                  v-if="presumptiveDataEach.case_found_at == 5"
                  class="ml-3"
                  @click="viewFollowUp"
                  >View</v-btn
                >
              </td>
              <td
                v-if="
                  presumptiveDataEach.case_found_at == 2 ||
                  presumptiveDataEach.case_found_at == 3
                "
              >
                {{
                  presumptiveDataEach.relationship == 1
                    ? "Household Contact"
                    :  presumptiveDataEach.relationship == 3 ? "Close Contact" : 
                    presumptiveDataEach.relationship == 4 ? "Other Contact" : ''
                }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    presumptiveDataEach: {
      type: Object,
    },
  },
  methods: {
    viewFollowUp() {
      this.$store
        .dispatch("Patient/getPatientByIndexCode", {
          township_id: this.presumptiveDataEach.township_id,
          index_case_no: this.presumptiveDataEach.index_case_no,
          index_case_year: this.presumptiveDataEach.index_case_year,
          index_case_initial: this.presumptiveDataEach.index_case_initial
            ? this.presumptiveDataEach.index_case_initial
            : "",
        })
        .then((response) => {
          if (response.data.data)
            this.$router.push({
              name: "patient-edit",
              params: {
                township_id: this.presumptiveDataEach.township_id,
                id: response.data.data.id,
              },
            });
        });
      // Patient.getByIndexCode({
      //   township_id: this.presumptiveDataEach.township_id,
      //   index_case_no: this.presumptiveDataEach.index_case_no,
      //   index_case_year: this.presumptiveDataEach.index_case_year,
      //   index_case_initial: this.presumptiveDataEach.index_case_initial
      //     ? this.presumptiveDataEach.index_case_initial
      //     : "",
      // }).then((response) => {
      //   if (response.data.data) {
      //   }
      // });
    },
  },
};
</script>

<style scoped>
.card--title {
  letter-spacing: 2px;
  font-size: 20px;
  font-weight: 400;
}
th,
td {
  font-size: 15px !important;
}
</style>